export default __webpack_public_path__ + "static/media/casino.08243018.png";